module.exports = __webpack_public_path__ + "static/media/paco-rabanne-pure-excess-big.71a062f8.png";